import type { LangMap } from "./index";

export const flashcards: LangMap = {
  en: {
    eyebrow: "Study",
    title: "Flashcards",
    subtitle: "Generate cards with AI and review with the Leitner method.",
    tabReview: "Review",
    tabDecks: "Decks",
    tabCreate: "Create",
    reviewDoneToast: "Review done! Great job 🌱",
    loading: "Loading…",
    deckEmpty: "This deck is empty.",
    nothingToReview: "No cards to review right now.",
    backToDecksHint: "Go back to Decks to pick another one.",
    generateOrComeBack: "Generate a new deck or come back later.",
    backToReview: "Back to review",
    allDecks: "All decks",
    cardOf: "Card {{current}} of {{total}}",
    boxOf: "Box {{box}}/5",
    answer: "Answer",
    question: "Question",
    tapToFlip: "Tap to flip",
    rateAgain: "Again",
    rateHard: "Hard",
    rateGood: "Easy",
    showAnswer: "Show answer",
    emptyDecks: "No decks yet. Create one in the \"Create\" tab.",
    topicLabel: "Topic",
    topicPlaceholder: "E.g. Cold War",
    subjectLabel: "Subject (optional)",
    subjectPlaceholder: "E.g. History",
    sourceLabel: "Source text (optional)",
    sourcePlaceholder: "Paste notes, or attach an audio (lecture) or photo (notes / book).",
    countLabel: "Number of cards: {{count}}",
    generating: "Generating cards…",
    generateWithAi: "Generate with AI",
    createdToast: "Created \"{{title}}\" with {{count}} cards",
  },
  it: {
    eyebrow: "Studio",
    title: "Flashcard",
    subtitle: "Genera carte dall'IA e ripassa col metodo Leitner.",
    tabReview: "Ripasso",
    tabDecks: "Mazzi",
    tabCreate: "Crea",
    reviewDoneToast: "Ripasso finito! Ottimo lavoro 🌱",
    loading: "Caricamento…",
    deckEmpty: "Questo mazzo è vuoto.",
    nothingToReview: "Nessuna carta da ripassare adesso.",
    backToDecksHint: "Torna a Mazzi per sceglierne un altro.",
    generateOrComeBack: "Genera un nuovo mazzo o torna piu' tardi.",
    backToReview: "Torna al ripasso",
    allDecks: "Tutti i mazzi",
    cardOf: "Carta {{current}} di {{total}}",
    boxOf: "Box {{box}}/5",
    answer: "Risposta",
    question: "Domanda",
    tapToFlip: "Tocca per girare",
    rateAgain: "Da ripetere",
    rateHard: "Difficile",
    rateGood: "Facile",
    showAnswer: "Mostra risposta",
    emptyDecks: "Nessun mazzo ancora. Creane uno nella scheda \"Crea\".",
    topicLabel: "Argomento",
    topicPlaceholder: "Es. Guerra fredda",
    subjectLabel: "Materia (opzionale)",
    subjectPlaceholder: "Es. Storia",
    sourceLabel: "Testo di partenza (opzionale)",
    sourcePlaceholder: "Incolla appunti, oppure allega un audio (lezione) o una foto (appunti / libro).",
    countLabel: "Numero carte: {{count}}",
    generating: "Genero le carte…",
    generateWithAi: "Genera con IA",
    createdToast: "Creato \"{{title}}\" con {{count}} carte",
  },
  es: {
    eyebrow: "Estudio",
    title: "Tarjetas",
    subtitle: "Genera tarjetas con IA y repasa con el método Leitner.",
    tabReview: "Repaso",
    tabDecks: "Mazos",
    tabCreate: "Crear",
    reviewDoneToast: "¡Repaso terminado! Buen trabajo 🌱",
    loading: "Cargando…",
    deckEmpty: "Este mazo está vacío.",
    nothingToReview: "No hay tarjetas para repasar ahora.",
    backToDecksHint: "Vuelve a Mazos para elegir otro.",
    generateOrComeBack: "Genera un nuevo mazo o vuelve más tarde.",
    backToReview: "Volver al repaso",
    allDecks: "Todos los mazos",
    cardOf: "Tarjeta {{current}} de {{total}}",
    boxOf: "Caja {{box}}/5",
    answer: "Respuesta",
    question: "Pregunta",
    tapToFlip: "Toca para girar",
    rateAgain: "Repetir",
    rateHard: "Difícil",
    rateGood: "Fácil",
    showAnswer: "Mostrar respuesta",
    emptyDecks: "Aún no hay mazos. Crea uno en la pestaña \"Crear\".",
    topicLabel: "Tema",
    topicPlaceholder: "Ej. Guerra fría",
    subjectLabel: "Materia (opcional)",
    subjectPlaceholder: "Ej. Historia",
    sourceLabel: "Texto de partida (opcional)",
    sourcePlaceholder: "Pega apuntes, o adjunta un audio (clase) o una foto (apuntes / libro).",
    countLabel: "Número de tarjetas: {{count}}",
    generating: "Generando las tarjetas…",
    generateWithAi: "Generar con IA",
    createdToast: "Creado \"{{title}}\" con {{count}} tarjetas",
  },
  fr: {
    eyebrow: "Étude",
    title: "Flashcards",
    subtitle: "Génère des cartes avec l'IA et révise avec la méthode Leitner.",
    tabReview: "Révision",
    tabDecks: "Paquets",
    tabCreate: "Créer",
    reviewDoneToast: "Révision terminée ! Excellent travail 🌱",
    loading: "Chargement…",
    deckEmpty: "Ce paquet est vide.",
    nothingToReview: "Aucune carte à réviser pour l'instant.",
    backToDecksHint: "Retourne dans Paquets pour en choisir un autre.",
    generateOrComeBack: "Génère un nouveau paquet ou reviens plus tard.",
    backToReview: "Retour à la révision",
    allDecks: "Tous les paquets",
    cardOf: "Carte {{current}} sur {{total}}",
    boxOf: "Boîte {{box}}/5",
    answer: "Réponse",
    question: "Question",
    tapToFlip: "Touche pour retourner",
    rateAgain: "À refaire",
    rateHard: "Difficile",
    rateGood: "Facile",
    showAnswer: "Afficher la réponse",
    emptyDecks: "Aucun paquet pour l'instant. Crée-en un dans l'onglet \"Créer\".",
    topicLabel: "Sujet",
    topicPlaceholder: "Ex. Guerre froide",
    subjectLabel: "Matière (optionnel)",
    subjectPlaceholder: "Ex. Histoire",
    sourceLabel: "Texte source (optionnel)",
    sourcePlaceholder: "Colle des notes, ou joins un audio (cours) ou une photo (notes / livre).",
    countLabel: "Nombre de cartes : {{count}}",
    generating: "Génération des cartes…",
    generateWithAi: "Générer avec l'IA",
    createdToast: "« {{title}} » créé avec {{count}} cartes",
  },
  de: {
    eyebrow: "Lernen",
    title: "Karteikarten",
    subtitle: "Erstelle Karten mit KI und wiederhole mit der Leitner-Methode.",
    tabReview: "Wiederholung",
    tabDecks: "Stapel",
    tabCreate: "Erstellen",
    reviewDoneToast: "Wiederholung beendet! Toll gemacht 🌱",
    loading: "Wird geladen…",
    deckEmpty: "Dieser Stapel ist leer.",
    nothingToReview: "Gerade keine Karten zu wiederholen.",
    backToDecksHint: "Gehe zurück zu Stapel, um einen anderen auszuwählen.",
    generateOrComeBack: "Erstelle einen neuen Stapel oder komm später zurück.",
    backToReview: "Zurück zur Wiederholung",
    allDecks: "Alle Stapel",
    cardOf: "Karte {{current}} von {{total}}",
    boxOf: "Box {{box}}/5",
    answer: "Antwort",
    question: "Frage",
    tapToFlip: "Tippen zum Umdrehen",
    rateAgain: "Nochmal",
    rateHard: "Schwer",
    rateGood: "Leicht",
    showAnswer: "Antwort anzeigen",
    emptyDecks: "Noch keine Stapel. Erstelle einen im Tab \"Erstellen\".",
    topicLabel: "Thema",
    topicPlaceholder: "Z. B. Kalter Krieg",
    subjectLabel: "Fach (optional)",
    subjectPlaceholder: "Z. B. Geschichte",
    sourceLabel: "Ausgangstext (optional)",
    sourcePlaceholder: "Füge Notizen ein oder hänge eine Audiodatei (Vorlesung) oder ein Foto (Notizen / Buch) an.",
    countLabel: "Anzahl Karten: {{count}}",
    generating: "Karten werden erstellt…",
    generateWithAi: "Mit KI generieren",
    createdToast: "\"{{title}}\" mit {{count}} Karten erstellt",
  },
  pt: {
    eyebrow: "Estudo",
    title: "Flashcards",
    subtitle: "Gere cartões com IA e revise com o método Leitner.",
    tabReview: "Revisão",
    tabDecks: "Baralhos",
    tabCreate: "Criar",
    reviewDoneToast: "Revisão concluída! Ótimo trabalho 🌱",
    loading: "Carregando…",
    deckEmpty: "Este baralho está vazio.",
    nothingToReview: "Nenhum cartão para revisar agora.",
    backToDecksHint: "Volte a Baralhos para escolher outro.",
    generateOrComeBack: "Gere um novo baralho ou volte mais tarde.",
    backToReview: "Voltar à revisão",
    allDecks: "Todos os baralhos",
    cardOf: "Cartão {{current}} de {{total}}",
    boxOf: "Caixa {{box}}/5",
    answer: "Resposta",
    question: "Pergunta",
    tapToFlip: "Toque para virar",
    rateAgain: "Repetir",
    rateHard: "Difícil",
    rateGood: "Fácil",
    showAnswer: "Mostrar resposta",
    emptyDecks: "Nenhum baralho ainda. Crie um na aba \"Criar\".",
    topicLabel: "Tópico",
    topicPlaceholder: "Ex. Guerra Fria",
    subjectLabel: "Matéria (opcional)",
    subjectPlaceholder: "Ex. História",
    sourceLabel: "Texto de origem (opcional)",
    sourcePlaceholder: "Cole anotações, ou anexe um áudio (aula) ou uma foto (anotações / livro).",
    countLabel: "Número de cartões: {{count}}",
    generating: "Gerando os cartões…",
    generateWithAi: "Gerar com IA",
    createdToast: "Criado \"{{title}}\" com {{count}} cartões",
  },
};
